import { render, staticRenderFns } from "./workbench.vue?vue&type=template&id=59e0cc34&scoped=true"
import script from "./workbench.vue?vue&type=script&lang=js"
export * from "./workbench.vue?vue&type=script&lang=js"
import style0 from "./workbench.vue?vue&type=style&index=0&id=59e0cc34&prod&scoped=true&lang=less"
import style1 from "./workbench.vue?vue&type=style&index=1&id=59e0cc34&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e0cc34",
  null
  
)

export default component.exports